import CancelIcon from "@mui/icons-material/Cancel";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { api_Routes } from "../../../tools/api_Routes";
import { Helper } from "../../../tools/Helper";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setSuccess } from "../../../Redux/AlertReducer";

const SectionCard = ({
  title,
  children,
  sectionKey,
  icon,
  setEditingSection,
  setFormData,
  editingSection,
  formData = {},
  data,
}) => {
  const [sId, setsId] = useState(0);
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    const getId = () => {
      Object.entries(data).map(([key, value]) => {
        if (key === sectionKey) setsId(value.id);
      });
    };
    getId();
  }, []);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const handleSave = async () => {
    setIsLoading(true);
    const url =
      sectionKey === "pin"
        ? api_Routes.PinsAdvertising.Edit + sId
        : sectionKey === "banner"
        ? api_Routes.BannersAdvertising.Edit + sId
        : sectionKey === "trust"
        ? api_Routes.Trust.Edit + id
        : api_Routes.TicketsAdvertising.Edit + sId;
    const formDataToSend = new FormData();
    Object.entries(formData).map(([key, value]) => {
      if (key === sectionKey) {
        for (let key1 in value) {
          formDataToSend.append(key1, value[key1]);
        }
      }
    });
    try {
      const { result, response, message } = await Helper.Put({
        url: url,
        data: formDataToSend,
        isFormData: true,
      });

      if (response) {
        dispatch(setSuccess(true));
        navigate(`/Orders/${id}`);
      }
    } catch (error) {
      console.error("An error occurred during form submission:", error);
    }
    setIsLoading(false);
    setEditingSection(null);
  };

  const handleEditClick = (section) => {
    setEditingSection(section);
  };

  const handleCancel = () => {
    setEditingSection(null);
    setFormData(data);
  };
  return (
    <Card
      sx={{
        minWidth: 300,
        maxWidth: 400,
        m: 2,
        borderRadius: 4,
        boxShadow: "0px 8px 24px rgba(149, 157, 165, 0.2)",
        transition: "transform 0.2s",
        "&:hover": { transform: "translateY(-4px)" },
      }}
    >
      <CardHeader
        avatar={
          <Avatar sx={{ bgcolor: theme.palette.primary.main }}>{icon}</Avatar>
        }
        title={
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {title}
          </Typography>
        }
        action={
          sectionKey !== "top_result" && sectionKey !== "order" ? (
            <IconButton
              onClick={() =>
                editingSection === sectionKey
                  ? handleCancel()
                  : handleEditClick(sectionKey)
              }
            >
              {editingSection === sectionKey ? (
                <CancelIcon color="error" />
              ) : (
                <EditIcon color="primary" />
              )}
            </IconButton>
          ) : (
            <></>
          )
        }
        sx={{
          bgcolor: theme.palette.primary.light,
          py: 1,
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
        }}
      />
      <CardContent sx={{ bgcolor: "#f8f9fa", minHeight: 200 }}>
        {children}
        {editingSection === sectionKey && (
          <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
            <Button
              variant="contained"
              startIcon={<SaveIcon />}
              onClick={handleSave}
              fullWidth
              sx={{ borderRadius: 2 }}
            >
              {isLoading ? "Saving.." : "Save"}
            </Button>
            <Button
              variant="outlined"
              onClick={handleCancel}
              fullWidth
              sx={{ borderRadius: 2 }}
            >
              Cancel
            </Button>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};
export default SectionCard;
